exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ele-import-action{margin-top:20px;text-align:center}", ""]);

// exports
